import $ from 'jquery'

var intmeg = setInterval(function () {
  if ($('.Megamenu').hasClass('is-ready')) {
    menufn();
    clearInterval(intmeg);
  }
}, 500);

function menufn() {

  $('ul.Megamenu > li.Megamenu-item > a[aria-expanded]')
    .on('click', function (e) {
      e.preventDefault();
    })
    .dblclick(function (e) {
      document.location = $(this).attr('page_menu_activeref');
    });

  $('ul.Megamenu [data-icon]').each(function () {
    $(this).addClass('fa fa-fw fa-' + $(this).data('icon'));
  });

  if ($(window).height() < 1024) {
    $('.Megamenu-subnav').each(function () {
      if ($(this).find('.Megamenu-subnavGroup').length > 3) {
        $(this).addClass('big');
      }
    });
  }
}

$('.Linklist-link.is-collapsed').click(function (e) {
  e.preventDefault();
  $(this).off('click').find('+ul').hide().removeClass('u-hidden').slideDown();
});



// WEBPACK FOOTER //
// ./src/themes/pac/js/menu.js